module.exports = __webpack_public_path__ + "static/private-cloudfront-config-1-75663714543eefc387f639ec1d006bbe.png";